import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import {
  Divider,
  Grid,
  Header,
  Segment,
  Table,
  Tab,
  Dropdown,
  Checkbox,
  Button
} from 'semantic-ui-react';
import { history } from '../../_helpers/';
import { servicesAPI, useCustomers } from '../../_services';
import { dbUTCDatetimeToLocal } from '../../utils';

const statusOptions = [
  { text: 'Submitted', value: 'SUBMITTED' },
  { text: 'Approved', value: 'APPROVED' },
  { text: 'Rejected', value: 'REJECTED' }
];

export const ListAONSurveys = () => {
  const customers = useCustomers();

  const [signups, setSignUps] = useState(null);
  const [surveys, setSurveys] = useState(null);

  const [submittedSurveys, setSubmittedSurveys] = useState([]);
  const [partialSurveys, setPartialSurveys] = useState([]);
  const [requestedSurveys, setRequestedSurveys] = useState([]);

  const [applyFilter, setApplyFilter] = useState(false);
  const [showTestAccounts, setShowTestAccounts] = useState(false);
  const [statusFilter, setStatusFilter] = useState(['SUBMITTED', 'APPROVED']);
  const [sortColumn, setSortColumn] = useState('created_datetime');
  const [sortDirection, setSortDirection] = useState('desc');
  const [sortLabel, setSortLabel] = useState('descending');

  // useEffect(() => {
  //   if (tabIndex === 1) {
  //   }
  // }, [tabIndex]);

  const sortTable = column => {
    setSortColumn(column);
    setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    setSortLabel(sortLabel === 'ascending' ? 'descending' : 'ascending');
  };

  useEffect(() => {
    servicesAPI
      .AdminServices('getStatesByEntityType', 'AON_SIGN_UP')
      .then(signups => {
        let newSignups = [];
        for (const id of Object.keys(signups)) {
          newSignups.push({
            ...JSON.parse(signups[id]),
            customer_id: id
          });
        }
        setSignUps(newSignups);
      });

    servicesAPI
      .AdminServices('getSurveys')
      .then(surveys => setSurveys(surveys));

    sortTable('created_datetime');
    setSortDirection('desc');
    setSortLabel('descending');
  }, []);

  useEffect(() => {
    if (!signups || !surveys || customers.length === 0) return;
    let aonSurveys = [];
    surveys
      .filter(survey => survey.id.startsWith('AONSurvey'))
      .map(survey => {
        // Unpack survey responses and calculate progress
        let totalSteps = 0;
        let completedSteps = 0;
        let lastCompletedStep = '';

        if (survey.data) {
          const data = JSON.parse(survey.data);
          if (data.responses) {
            totalSteps = data.responses.length;
            completedSteps = 0;
            data.responses.forEach(response => {
              if (response) {
                lastCompletedStep = response?.name ? response.name : '';
                completedSteps++;
              }
            });

            // Ignore first and last steps which aren't questions
            if (totalSteps >= 2) totalSteps -= 2;
          }

          return {
            ...data,
            ...survey,
            customer_id: survey.id.replace('AONSurvey_', ''),
            total_steps: totalSteps,
            completed_steps: completedSteps,
            last_completed_step: lastCompletedStep
          };
        } else {
          return {
            ...survey,
            customer_id: survey.id.replace('AONSurvey_', ''),
            total_steps: totalSteps,
            completed_steps: completedSteps,
            last_completed_step: lastCompletedStep
          };
        }
      })
      .forEach(survey => {
        const customer = customers.find(c => c.id === survey.customer_id);
        if (!customer) {
          console.log(survey.id);
          return;
        }
        customer.address_postcode = customer.address_postcode.toUpperCase();

        const name = customer
          ? customer.forename + ' ' + customer.surname
          : '\\_(ツ)_/';

        let address = [];
        let address_postcode = '';
        if (customer?.address_line1) address.push(customer.address_line1);
        if (customer?.address_line2) address.push(customer.address_line2);
        if (customer?.address_city) address.push(customer.address_city);
        if (customer?.address_country_region)
          address.push(customer.address_country_region);
        if (customer?.address_county) address.push(customer.address_county);
        if (customer?.address_postcode) {
          address_postcode = customer.address_postcode;
          address.push(address_postcode);
        }
        address = address.join(', ');

        aonSurveys.push({
          ...survey,
          customer_name: name,
          customer_address: address,
          customer_postcode: address_postcode,
          test_account: customer?.test_account,
          sortable_postcode: address_postcode.replace(/\s/g, '')
        });
      });

    const sorted =
      sortColumn && sortDirection
        ? _.orderBy(aonSurveys, sortColumn, sortDirection)
        : aonSurveys;

    setPartialSurveys(
      sorted
        .filter(({ status }) => status === 'IN_PROGRESS')
        .filter(
          ({ test_account }) =>
            (showTestAccounts && test_account) || !test_account
        )
    );

    setSubmittedSurveys(
      sorted
        .filter(({ status }) => !statusFilter || statusFilter.includes(status))
        .filter(
          ({ test_account }) =>
            (showTestAccounts && test_account) || !test_account
        )
    );

    // Requested surveys
    let requestedSurveys = signups.filter(
      signup => signup.self_survey === false && !signup.survey_completed
    );

    requestedSurveys = requestedSurveys.map(s => {
      const customer = customers.find(c => c.id === s.customer_id);

      const name = customer
        ? customer.forename + ' ' + customer.surname
        : '\\_(ツ)_/';

      let address = [];
      let address_postcode = '';
      if (customer?.address_line1) address.push(customer.address_line1);
      if (customer?.address_line2) address.push(customer.address_line2);
      if (customer?.address_city) address.push(customer.address_city);
      if (customer?.address_country_region)
        address.push(customer.address_country_region);
      if (customer?.address_county) address.push(customer.address_county);
      if (customer?.address_postcode) {
        address_postcode = customer.address_postcode;
        address.push(address_postcode);
      }
      address = address.join(', ');

      return {
        ...s,
        customer_name: name,
        customer_address: address,
        customer_postcode: address_postcode,
        test_account: customer?.test_account,
        sortable_postcode: address_postcode.replace(/\s/g, '')
      };
    });

    setRequestedSurveys(requestedSurveys);
  }, [
    signups,
    surveys,
    customers,
    applyFilter,
    // statusFilter,
    sortColumn,
    sortDirection
  ]);

  return (
    <Segment>
      <Tab
        menu={{ secondary: true, pointing: true, tabular: false }}
        panes={[
          {
            menuItem: `Submitted HOME Surveys (${submittedSurveys.length})`,
            render: () => (
              <Tab.Pane attached={false}>
                <Grid stretched>
                  <Grid.Row>
                    <Grid.Column>
                      <Header as="h2">
                        Submitted HOME Surveys ({submittedSurveys.length})
                      </Header>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
                <Divider hidden />
                <Grid stretched>
                  <Grid.Row>
                    <Grid.Column mobile={8} tablet={6} computer={4}>
                      <Dropdown
                        placeholder="filter status"
                        selection
                        search
                        options={statusOptions}
                        multiple
                        onChange={(e, inputProps) => {
                          setStatusFilter(inputProps.value);
                        }}
                        value={statusFilter}
                      />
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column>
                      <Checkbox
                        toggle
                        label="Show test accounts"
                        checked={showTestAccounts}
                        onChange={e => setShowTestAccounts(!showTestAccounts)}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
                <br />
                <Grid.Row>
                  <Grid.Column>
                    <Button
                      color="olive"
                      onClick={() => setApplyFilter(!applyFilter)}
                    >
                      Apply Filters
                    </Button>
                  </Grid.Column>
                </Grid.Row>
                <Divider hidden />
                <Grid>
                  <Table
                    basic="very"
                    selectable
                    sortable
                    stackable
                    celled
                    fixed
                  >
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell
                          style={{ width: '110px' }}
                          sorted={
                            sortColumn === 'created_datetime' ? sortLabel : null
                          }
                          onClick={() => sortTable('created_datetime')}
                        >
                          Survey Submission
                          <br />
                          Date/Time
                        </Table.HeaderCell>
                        <Table.HeaderCell
                          style={{ width: '190px' }}
                          sorted={
                            sortColumn === 'customer_name' ? sortLabel : null
                          }
                          onClick={() => sortTable('customer_name')}
                        >
                          Customer Name
                        </Table.HeaderCell>
                        <Table.HeaderCell style={{ width: '300px' }}>
                          Address
                        </Table.HeaderCell>
                        <Table.HeaderCell
                          style={{ width: '100px' }}
                          sorted={
                            sortColumn === 'sortable_postcode'
                              ? sortLabel
                              : null
                          }
                          onClick={() => sortTable('sortable_postcode')}
                        >
                          Postcode
                        </Table.HeaderCell>
                        <Table.HeaderCell
                          style={{ width: '90px' }}
                          sorted={sortColumn === 'status' ? sortLabel : null}
                          onClick={() => sortTable('status')}
                        >
                          Status
                        </Table.HeaderCell>
                        <Table.HeaderCell
                          style={{ width: '180px' }}
                          sorted={
                            sortColumn === 'project_reference'
                              ? sortLabel
                              : null
                          }
                          onClick={() => sortTable('project_reference')}
                        >
                          Project Ref.
                        </Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>
                    <Table.Body>
                      {submittedSurveys.map((survey, idx) => (
                        <Table.Row
                          key={idx}
                          onClick={() => {
                            history.push(`/admin/aon/survey/${survey.id}`);
                          }}
                        >
                          <Table.Cell>
                            {dbUTCDatetimeToLocal(survey.created_datetime)}
                          </Table.Cell>
                          <Table.Cell>{survey.customer_name}</Table.Cell>
                          <Table.Cell>{survey.customer_address}</Table.Cell>
                          <Table.Cell>{survey.customer_postcode}</Table.Cell>
                          <Table.Cell>{survey.status}</Table.Cell>
                          <Table.Cell>{survey.project_reference}</Table.Cell>
                        </Table.Row>
                      ))}
                    </Table.Body>
                  </Table>
                </Grid>
              </Tab.Pane>
            )
          },
          {
            menuItem: `In Progress HOME Surveys (${partialSurveys.length})`,
            render: () => (
              <Tab.Pane attached={false}>
                <Grid stretched>
                  <Grid.Row>
                    <Grid.Column>
                      <Header as="h2">
                        In Progress HOME Surveys ({partialSurveys.length})
                      </Header>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
                <Divider hidden />
                <Grid stretched>
                  <Grid.Row>
                    <Grid.Column>
                      <Checkbox
                        toggle
                        label="Show test accounts"
                        checked={showTestAccounts}
                        onChange={e => setShowTestAccounts(!showTestAccounts)}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
                <br />
                <Grid.Row>
                  <Grid.Column>
                    <Button
                      color="olive"
                      onClick={() => setApplyFilter(!applyFilter)}
                    >
                      Apply Filters
                    </Button>
                  </Grid.Column>
                </Grid.Row>
                <Divider hidden />
                <Grid>
                  <Table
                    basic="very"
                    selectable
                    sortable
                    stackable
                    celled
                    fixed
                  >
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell
                          style={{ width: '110px' }}
                          sorted={
                            sortColumn === 'created_datetime' ? sortLabel : null
                          }
                          onClick={() => sortTable('created_datetime')}
                        >
                          Survey Started
                          <br />
                          Date/Time
                        </Table.HeaderCell>
                        <Table.HeaderCell
                          style={{ width: '190px' }}
                          sorted={
                            sortColumn === 'customer_name' ? sortLabel : null
                          }
                          onClick={() => sortTable('customer_name')}
                        >
                          Customer Name
                        </Table.HeaderCell>
                        <Table.HeaderCell style={{ width: '300px' }}>
                          Address
                        </Table.HeaderCell>
                        <Table.HeaderCell
                          style={{ width: '100px' }}
                          sorted={
                            sortColumn === 'sortable_postcode'
                              ? sortLabel
                              : null
                          }
                          onClick={() => sortTable('sortable_postcode')}
                        >
                          Postcode
                        </Table.HeaderCell>
                        <Table.HeaderCell
                          style={{ width: '180px' }}
                          sorted={
                            sortColumn === 'project_reference'
                              ? sortLabel
                              : null
                          }
                          onClick={() => sortTable('project_reference')}
                        >
                          Project Ref.
                        </Table.HeaderCell>
                        <Table.HeaderCell style={{ width: '220px' }}>
                          Steps
                          <br />
                          Completed
                        </Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>
                    <Table.Body>
                      {partialSurveys.map((survey, idx) => (
                        <Table.Row
                          key={idx}
                          onClick={() => {
                            history.push(`/admin/aon/survey/${survey.id}`);
                          }}
                        >
                          <Table.Cell>
                            {dbUTCDatetimeToLocal(survey.created_datetime)}
                          </Table.Cell>
                          <Table.Cell>{survey.customer_name}</Table.Cell>
                          <Table.Cell>{survey.customer_address}</Table.Cell>
                          <Table.Cell>{survey.customer_postcode}</Table.Cell>
                          <Table.Cell>{survey.project_reference}</Table.Cell>
                          <Table.Cell>
                            {survey.completed_steps} / {survey.total_steps}
                            <br />({survey.last_completed_step})
                          </Table.Cell>
                        </Table.Row>
                      ))}
                    </Table.Body>
                  </Table>
                </Grid>
              </Tab.Pane>
            )
          },
          {
            menuItem: `Requested HOME Surveys (${requestedSurveys.length})`,
            render: () => (
              <Tab.Pane attached={false}>
                <Grid stretched>
                  <Grid.Row>
                    <Grid.Column>
                      <Header as="h2">
                        Requested HOME Surveys ({requestedSurveys.length})
                      </Header>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
                <Divider hidden />
                <Grid>
                  <Table basic="very" selectable stackable celled fixed>
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell style={{ width: '220px' }}>
                          Customer Name
                        </Table.HeaderCell>
                        <Table.HeaderCell style={{ width: '300px' }}>
                          Address
                        </Table.HeaderCell>
                        <Table.HeaderCell
                          style={{ width: '110px' }}
                          sorted={
                            sortColumn === 'sortable_postcode'
                              ? sortLabel
                              : null
                          }
                          onClick={() => sortTable('sortable_postcode')}
                        >
                          Postcode
                        </Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>
                    <Table.Body>
                      {requestedSurveys.map((survey, idx) => (
                        <Table.Row key={idx}>
                          <Table.Cell
                            onClick={() => {
                              history.push(
                                `/admin/aon/survey/AONSurvey_${survey.customer_id}`
                              );
                            }}
                          >
                            {survey.customer_name}
                          </Table.Cell>
                          <Table.Cell
                            onClick={() => {
                              history.push(
                                `/admin/aon/survey/AONSurvey_${survey.customer_id}`
                              );
                            }}
                          >
                            {survey.customer_address}
                          </Table.Cell>
                          <Table.Cell>{survey.customer_postcode}</Table.Cell>
                        </Table.Row>
                      ))}
                    </Table.Body>
                  </Table>
                </Grid>
              </Tab.Pane>
            )
          }
        ]}
      />
    </Segment>
  );
};
